export const ORDER_TYPES = {
  SALE: 'SALE',
  SERVICE: 'SERVICE'
}
